// @ts-ignore
import Keycloak from 'keycloak-js';

import { isCypressInstance } from '@tsl-frontend/tsl-cypress';

let keycloakInstance: Keycloak.KeycloakInstance;

const getKeycloakInstance = (
    keycloakUrl: string,
    keycloakRealm: string,
    clientId: string,
) => {
    if (isCypressInstance) {
        return (window as any).mockKeycloak;
    }

    if (keycloakInstance) {
        return keycloakInstance;
    }

    keycloakInstance = new (Keycloak as any)({
        url: keycloakUrl,
        realm: keycloakRealm,
        clientId,
    });

    return keycloakInstance;
};

const getKeycloakToken = async (): Promise<string | undefined> => {
    if (!keycloakInstance) {
        return;
    }
    try {
        if (keycloakInstance.isTokenExpired()) {
            await keycloakInstance.updateToken(5);
        }
        return keycloakInstance.token;
    } catch (error) {
        return;
    }
};

export { getKeycloakInstance, getKeycloakToken };
